import React from 'react';

import {
    AppBar as MuiAppBar,
    Toolbar,
    Typography,
    useMediaQuery,
    Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    LoadingIndicator,
    HideOnScroll,
    ToggleThemeButton,
    useSidebarState,
    SidebarToggleButton,
} from 'react-admin';

import {
    AdminNotifications,
} from '@src/custom';

const isStaging = process.env.FRONTEND_ENV !== 'production';

const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
    ...(isStaging && {
        backgroundImage: theme.palette.mode === 'dark'
            ? 'repeating-linear-gradient(135deg, #323232, #323232 10px, #222222 10px, #222222 20px)'
            : 'repeating-linear-gradient(135deg, #2296F3, #2296F3 10px, #50A9ED 10px, #50A9ED 20px)',
    }),
}));

const StyledToolbar = styled(Toolbar)({
    paddingRight: 24,
});

const StyledContent = styled('div', {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    marginLeft: open ? 264 : 64,
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
    },
}));

const StyledTypography = styled(Typography)({
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
});

const AppBarCustom = () => {
    const className = '';
    const color = 'secondary';
    const children = null;
    const [open] = useSidebarState();

    const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <HideOnScroll>
            <StyledAppBar className={className} color={color}>
                <StyledToolbar
                    disableGutters
                    variant={isXSmall ? 'regular' : 'dense'}
                >
                    <Box sx={{
                        marginLeft: '12px !important',
                        transition: 'all 0.3s ease-in-out',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    >
                        <SidebarToggleButton />
                    </Box>
                    <StyledContent open={open}>
                        {React.Children.count(children) === 0 ?
                            (
                                <StyledTypography
                                    variant="h6"
                                    color="inherit"
                                    id="react-admin-title"
                                />
                            ) :
                            (
                                children
                            )}
                        <ToggleThemeButton />
                        <AdminNotifications />
                        <LoadingIndicator />
                    </StyledContent>
                </StyledToolbar>
            </StyledAppBar>
        </HideOnScroll>
    );
};

export default AppBarCustom;
